// Subscription access rules for a signed-in student whose plan has ended or is
// paused.
//
// A student keeps the app until the paid period runs out; after that the
// expired-subscription wizard (or, for a paused plan, the paused gate) covers
// every screen except the ones listed here. Upsells (prompt packs, Claude pack)
// are one-time purchases, so the prompts library stays reachable for reading,
// copying and downloading — only the "try in the assistant" path is closed,
// because the assistant itself is gated, and nothing can be bought until the
// subscription is active again.

const ACTIVE_STUDENT_STATUSES = new Set(["active", "redemption"]);
export const UPSELL_LIBRARY_PATH_PREFIX = "/prompts-library";

// Paths a student without an active subscription may still open. The
// expired-subscription wizard does not auto-open on them and closes when the
// student navigates to one of them.
const EXPIRED_SUBSCRIPTION_ALLOWED_PATH_PREFIXES = [
    "/profile",
    "/terms",
    "/privacy",
    "/subscription-terms",
    "/experiment",
    "/payment/renew-success",
    "/reactivate",
    UPSELL_LIBRARY_PATH_PREFIX
];

/** "redemption" is a payment retry window: the student still has access. */
export const hasSubscriptionAccess = (status?: string | null): boolean =>
    typeof status === "string" && ACTIVE_STUDENT_STATUSES.has(status);

export const isUpsellLibraryPath = (pathname: string): boolean => pathname.startsWith(UPSELL_LIBRARY_PATH_PREFIX);

export const isExpiredSubscriptionAllowedPath = (pathname: string): boolean =>
    EXPIRED_SUBSCRIPTION_ALLOWED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
